import { createAsyncThunk } from '@reduxjs/toolkit'
import { getMarketIndexes, MarketIndexes } from '../../../api/v1/market'
import { PRIMARY_CURRENCY } from '../../../constants/currencies'

export const getMarketIndexesAction = createAsyncThunk<MarketIndexes>(
  'market/getMarketIndexesAction',
  async () => {
    const r = await getMarketIndexes()
    const { data } = r
    if (data[PRIMARY_CURRENCY] === undefined) {
      data[PRIMARY_CURRENCY] = [new Date().getTime(), '1.0']
    }
    return data
  },
)
